import React from 'react'
import Footer from '../component/Footer/Footer'
import { Helmet } from 'react-helmet'
import HomeCustomTextContent from '../component/HomeCustomTextContent/HomeCustomTextContent'
import ExpertiseSection from '../component/ExpertiseSection/ExpertiseSection'
import HomeProgram from '../component/HomeProgram/HomeProgram'
import HomeApproachText from '../component/HomeApproachText/HomeApproachText'
import HomeHero from '../component/HomeHero/HomeHero'
import Header from '../component/Header/Header'
import TeamLdCare from '../component/TeamLdCare/TeamLdCare'
import TestimonialsNew from '../component/InstaImageGallery/InstaImageGallery'


const textDropDown = [
    {
      title:"Coaching & Clinicians",
      content:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s"
    },
    {
      title:"Rider Development Program",
      content:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s"
    }
  ]


const serviceData=[
    {
        icon:"/images/icons/service-card-icon-1.png",
        heading:"Yearly Executive Health Assessments",
        content:"In-depth screenings to stay ahead of potential health issues.",
        btnText:"Learn More",
        btnRef:"/"
    },
    {
        icon:"/images/icons/service-card-icon-2.png",
        heading:"Regular Follow-Ups & Coaching Calls",
        content:"Consistent touchpoints to keep your care plan on track.",
        btnText:"Learn More",
        btnRef:"/"
    },
    {
        icon:"/images/icons/service-card-icon-3.png",
        heading:"Global Health Support",
        content:"Seamless coordination, wherever life or business takes you.",
        btnText:"Learn More",
        btnRef:"/"
    },
    {
        icon:"/images/icons/service-card-icon-1.png",
        heading:"Yearly Executive Health Assessments",
        content:"In-depth screenings to stay ahead of potential health issues.",
        btnText:"Learn More",
        btnRef:"/"
    },
    {
        icon:"/images/icons/service-card-icon-2.png",
        heading:"Regular Follow-Ups & Coaching Calls",
        content:"Consistent touchpoints to keep your care plan on track.",
        btnText:"Learn More",
        btnRef:"/"
    },
    {
        icon:"/images/icons/service-card-icon-3.png",
        heading:"Global Health Support",
        content:"Seamless coordination, wherever life or business takes you.",
        btnText:"Learn More",
        btnRef:"/"
    },
    
]

function Home() {
  return (
    <div >
       <Helmet>
        <title>
        Executive Health Clinic in Toronto | Personalized Preventive Care
        </title>
        <link
          rel="canonical"
          href="https://thetorontoclinic.com/"
        />
        <meta
          name="description"
          content="Experience premium executive health care in Toronto with The Toronto Clinic - personalized wellness, preventive screenings, and holistic health programs."
        ></meta>
      </Helmet>
     
      <Header/>
     <HomeHero
      plainCta={false}
     />

      <div className='right-gradient-center'>

      <HomeCustomTextContent/>
      </div>

      {/* <div className='center-gradient-center'>

      <ExpertiseSection/>
      </div> */}

       <TeamLdCare
        noSwiper={true}
        noLearnMoreAnchor={true}
        imgBg={true}
        customBtnText='Meet The Team'
        cusBlueBtnRef={"/team"}
       />
      <HomeProgram
         mainCardHeading="A Comprehensive Program Designed to Empower You"
        mainCardPara="At The Toronto Clinic, we champion a holistic approach to your well-being. Our program initiates with an exhaustive health assessment, spotlighting and mitigating potential risks from the onset. Our commitment ensures you not only feel your best but also thrive with vigor, confidence, and vitality."
        btnText="Explore membership"
        btnRef="/membership"
        serviceData={serviceData}
        mainCardImg={'/images/creatives/course-main-card-img.png'}
      leftBottomBorderRadius={true}
      />

      <div className='left-gradient'>

      <HomeApproachText/>
      </div>


      <div className='center-gradient-center'>

        <TestimonialsNew/>

        <Footer
          newsletterSection={false}
        />
      </div>

</div>
  )
}

export default Home